const userRolesAndRights = {
  developer: {
    userType: "developer",
    rights: [
      "getAdminUsers",
      "assignPhysician",
      "updateExternalPhysicianPaymentDetails",
      "getAdminUserClients",
      "getAdminUserClientDetails",
      "adminUserResetPassword",
      "getVideoAudioToken",
      "updatePatientDetailsByClient",
      "getCaseByClient",
      "updateCaseDetailsByClient",
      "getVideoAudioTokenByClient",
      "getTimeSlotsByClient",
      "scheduleByClient",
      "rescheduleByClient",
      "getChatsOfCaseByClient",
      "uploadImageByClient",
      "sentMessageByClient",
      "getCases",
      "getCasesDetails",
      "updateCase",
      "caseStatusModification",
      "caseConsultationTypeModification",
      "createCase",
      "createCaseStatus",
      "updateCaseStatus",
      "deleteCaseStatus",
      "getChatsOfCase",
      "uploadImageChats",
      "sentMessage",
      "getChatsOfPhysician",
      "clearNotification",
      "createClient",
      "getCategoryOfClient",
      "updateClient",
      "deleteClient",
      "getMessageTemplate",
      "getMessageTemplateDetails",
      "saveMessageTemplate",
      "updateMessageTemplate",
      "deleteMessageTemplate",
      "getPhysicianDetails",
      "getPhysicianCases",
      "getPhysicianCaseDetails",
      "updateCaseStatusByPhysician",
      "getPhysicianAvailability",
      "updatePrescription",
      "rxchangeCase",
      "consultCompleteReport",
      "consultNoRXReport",
      "clientCasesReport",
      "physicianCaseReport",
      "incompleteCasesReport",
      "getPhysicianConsultation",
      "getPhysicianTimeSlots",
      "scheduleConsultation",
      "rescheduleConsultation",
      "createState",
      "updateState",
      "deleteState",
      "searchState",
      "getStates",
      "getTeleMedicineCategory",
      "createTeleMedicineCategory",
      "updateTeleMedicineCategory",
      "deleteTeleMedicineCategory",
      "updateWheelStatus",
      "caseStatusModification",
      "caseTicketListing",
      "internalPhysicianChat",
      "getPhysicianForAdmin",
      "getPhysicianDetailsForAdmin",
      "provider.config:update",
      "provider.impersonation:read:many",
      "provider.impersonation:write:many",
      "adminUserUpdate",
    ],
    allowedUsers: [],
  },
  'it system admin': {
    userType: "it system admin",
    rights: [
      "registerPhysician",
      "getPhysicianDetailsForAdmin",
      "updatePhysicianDetails",
      "disable-provider",
      "getPhysicianForAdmin",
      "physicianModerationByAdmin",
      "getAdminUsers",
      "registerAdminUser",
      "adminUserUpdate",
      "adminUserDelete",
      "createPhysicianGroup",
      "getUserRoles",
      "getUserRoleDetails",
      "createUserRole",
      "updateUserRoleDetails",
      "deleteUserRoleDetails",
      "deactivateUser",
    ],
    allowedUsers: [
      'ops admin',
      'it system admin',
      'developer',
    ],
  },
  'ops admin': {
    userType: "ops admin",
    rights: [
      "assignPhysician",
      "getPhysicianForAdmin",
      "getPhysicianDetailsForAdmin",
      "updateExternalPhysicianPaymentDetails",
      "getAdminUsers",
      "adminUserView",
      "getAdminUserClients",
      "getAdminUserClientDetails",
      "adminUserResetPassword",
      "getVideoAudioToken",
      "updatePatientDetailsByClient",
      "getCaseByClient",
      "updateCaseDetailsByClient",
      "getVideoAudioTokenByClient",
      "getTimeSlotsByClient",
      "scheduleByClient",
      "rescheduleByClient",
      "getChatsOfCaseByClient",
      "uploadImageByClient",
      "sentMessageByClient",
      "getCases",
      "getCasesDetails",
      "updateCase",
      "caseStatusModification",
      "caseConsultationTypeModification",
      "createCase",
      "createCaseStatus",
      "updateCaseStatus",
      "deleteCaseStatus",
      "getChatsOfCase",
      "uploadImageChats",
      "sentMessage",
      "getChatsOfPhysician",
      "clearNotification",
      "createClient",
      "getCategoryOfClient",
      "updateClient",
      "deleteClient",
      "getMessageTemplate",
      "getMessageTemplateDetails",
      "saveMessageTemplate",
      "updateMessageTemplate",
      "deleteMessageTemplate",
      "getPhysicianDetails",
      "getPhysicianCases",
      "getPhysicianCaseDetails",
      "updateCaseStatusByPhysician",
      "getPhysicianAvailability",
      "updatePrescription",
      "rxchangeCase",
      "consultCompleteReport",
      "consultNoRXReport",
      "clientCasesReport",
      "physicianCaseReport",
      "incompleteCasesReport",
      "getPhysicianConsultation",
      "getPhysicianTimeSlots",
      "scheduleConsultation",
      "rescheduleConsultation",
      "createState",
      "updateState",
      "deleteState",
      "searchState",
      "getStates",
      "getTeleMedicineCategory",
      "createTeleMedicineCategory",
      "updateTeleMedicineCategory",
      "deleteTeleMedicineCategory",
      "getUserRoles",
      "getUserRoleDetails",
      "updateWheelStatus",
      "caseStatusModification",
      "caseTicketListing",
      "internalPhysicianChat",
      "getCases",
      "updatePhysicianSchedule",
      "provider.config:update",
      "adminUserUpdate",
    ],
    allowedUsers: [],
  },
  'ops admin (w/ impersonation)': {
    userType: "ops admin (w/ impersonation)",
    rights: [
      "assignPhysician",
      "getPhysicianForAdmin",
      "getPhysicianDetailsForAdmin",
      "updateExternalPhysicianPaymentDetails",
      "getAdminUsers",
      "adminUserView",
      "getAdminUserClients",
      "getAdminUserClientDetails",
      "adminUserResetPassword",
      "getVideoAudioToken",
      "updatePatientDetailsByClient",
      "getCaseByClient",
      "updateCaseDetailsByClient",
      "getVideoAudioTokenByClient",
      "getTimeSlotsByClient",
      "scheduleByClient",
      "rescheduleByClient",
      "getChatsOfCaseByClient",
      "uploadImageByClient",
      "sentMessageByClient",
      "getCases",
      "getCasesDetails",
      "updateCase",
      "caseStatusModification",
      "caseConsultationTypeModification",
      "createCase",
      "createCaseStatus",
      "updateCaseStatus",
      "deleteCaseStatus",
      "getChatsOfCase",
      "uploadImageChats",
      "sentMessage",
      "getChatsOfPhysician",
      "clearNotification",
      "createClient",
      "getCategoryOfClient",
      "updateClient",
      "deleteClient",
      "getMessageTemplate",
      "getMessageTemplateDetails",
      "saveMessageTemplate",
      "updateMessageTemplate",
      "deleteMessageTemplate",
      "getPhysicianDetails",
      "getPhysicianCases",
      "getPhysicianCaseDetails",
      "updateCaseStatusByPhysician",
      "getPhysicianAvailability",
      "updatePrescription",
      "rxchangeCase",
      "consultCompleteReport",
      "consultNoRXReport",
      "clientCasesReport",
      "physicianCaseReport",
      "incompleteCasesReport",
      "getPhysicianConsultation",
      "getPhysicianTimeSlots",
      "scheduleConsultation",
      "rescheduleConsultation",
      "createState",
      "updateState",
      "deleteState",
      "searchState",
      "getStates",
      "getTeleMedicineCategory",
      "createTeleMedicineCategory",
      "updateTeleMedicineCategory",
      "deleteTeleMedicineCategory",
      "getUserRoles",
      "getUserRoleDetails",
      "updateWheelStatus",
      "caseStatusModification",
      "caseTicketListing",
      "internalPhysicianChat",
      "getCases",
      "updatePhysicianSchedule",
      "provider.config:update",
      "provider.impersonation:read:many",
      "provider.impersonation:write:many",
      "adminUserUpdate",
    ],
    allowedUsers: [],
  },
};

export default userRolesAndRights;
